import type { PropsWithChildren } from 'react';

import { useRedirectHandler } from './hooks/useRedirectHandler';

export const StartAPetitionRedirectHandler: React.FC<PropsWithChildren> = ({ children }) => {
	const { data } = useRedirectHandler();

	if (data.isStepResolved) return <>{children}</>;

	return null;
};
